// ⚠️ This file is over 150 lines. Consider splitting it.
// Refactored: Steps extracted to child components
import React, { useState, useEffect, useRef } from 'react'
import StepOneDetails from './StepOneDetails'
import StepTwoAudienceTags from './StepTwoAudienceTags'
import StepFourCaptchaSubmit from './StepFourCaptchaSubmit'
import FormNavigation from './FormNavigation'

const EventForm = ({ onSubmit, initialData = null, skipCaptcha = false }) => {
    const defaultData = {
        firstName: '',
        lastName: '',
        phoneNumber: '',
        emailAddress: '',
        groupName: '',
        eventDetails: '',
        businessesInvolved: '',
        eventDateRanges: [{ startDate: '', endDate: '' }],
        startDate: '',
        endDate: '',
        promotionStartDate: '',
        promotionEndDate: '',
        commercial: '',
        additionalImages: [],
        contentRating: '',
        bar: '',
        dispensary: '',
        additionalTags: [],
        title: '',
        description: '',
        location: '',
        website: '',
        turnstile: '',
    }

    const [formData, setFormData] = useState(initialData ? { ...defaultData, ...initialData } : defaultData)

    const handleChange = (field, value) => {
        setFormData((prev) => ({ ...prev, [field]: value }))
    }


    const handleSubmit = (e) => {
        e.preventDefault()

        if (!formData.promotionStartDate || !formData.promotionEndDate) {
            alert('Please specify a promotion period for network broadcasting.')
            return
        }

        const payload = { ...formData }

        if (!skipCaptcha) {
            const captchaToken = document.querySelector('[name="cf-turnstile-response"]')?.value
            if (!captchaToken) {
                alert('CAPTCHA verification failed. Please try again.')
                return
            }
            payload.turnstile = captchaToken
        }

        onSubmit(payload)
    }

    const captchaRef = useRef(null)

    useEffect(() => {
        if (skipCaptcha) return

        let attempts = 0
        const tryRender = () => {
            if (window.turnstile && captchaRef.current) {
                window.turnstile.render(captchaRef.current, {
                    sitekey: import.meta.env.VITE_TURNSTILE_SITE_KEY,
                    callback: (token) => {
                        const el = document.querySelector('[name="cf-turnstile-response"]')
                        if (el) el.value = token
                    },
                    action: 'event_form',
                    theme: 'light',
                })
            } else if (attempts < 5) {
                attempts++
                setTimeout(tryRender, 300)
            } else {
                console.error('❌ Turnstile widget failed to load after multiple attempts.')
            }
        }

        tryRender()
    }, [skipCaptcha])

    const [step, setStep] = useState(0)
    const [errorFields, setErrorFields] = useState([])
    // Show a transient banner when validation fails
    const [showErrorBanner, setShowErrorBanner] = useState(false)
    // Advance to next step with validation
    const handleNext = () => {
        let missing = []
        if (step === 0) {
            if (!formData.title) missing.push('title')
            if (!formData.description) missing.push('description')
        } else if (step === 1) {
            if (!formData.contentRating) missing.push('contentRating')
            if (!formData.bar) missing.push('bar')
            if (!formData.dispensary) missing.push('dispensary')
            if (!formData.dogs) missing.push('dogs')
            if (!formData.commercial) missing.push('commercial')
        }
        if (missing.length) {
            setErrorFields(missing)
            setShowErrorBanner(true)
            // auto-hide banner after 4 seconds
            setTimeout(() => setShowErrorBanner(false), 4000)
            return
        }
        setErrorFields([])
        setStep((s) => Math.min(s + 1, totalSteps - 1))
    }
    const totalSteps = 3
    return (
        <section id="event-submission">
            <div className="contact-form p-1 md:p-8 rounded-lg max-w-4xl mx-auto my-2 md:my-8 pb-16 md:pb-8">
                <div className="flow">
                    <h1>Event Submission</h1>
                    <p>
                        Please provide your event details below. We’ll review and get back to you as soon as
                        possible.
                    </p>
                </div>
                {/* Transient validation banner */}
                {showErrorBanner && (
                    <div className="mb-4 bg-yellow-100 border-l-4 border-yellow-500 text-yellow-700 p-3 rounded transition-opacity duration-500">
                        <p className="text-sm">
                            Please complete the required fields highlighted below.
                        </p>
                    </div>
                )}
                <form id="event-form" onSubmit={handleSubmit} className="relative">
                    <StepOneDetails
                        step={step}
                        formData={formData}
                        errorFields={errorFields}
                        onChange={handleChange}
                    />
                    <StepTwoAudienceTags
                        step={step}
                        formData={formData}
                        errorFields={errorFields}
                        onChange={handleChange}
                    />
                    <StepFourCaptchaSubmit
                        step={step}
                        errorFields={errorFields}
                        captchaRef={captchaRef}
                    />
                    <FormNavigation
                        step={step}
                        totalSteps={totalSteps}
                        errorFields={errorFields}
                        onBack={() => {
                            setErrorFields([])
                            setStep((s) => Math.max(s - 1, 0))
                        }}
                        onNext={handleNext}
                    />
                </form>
            </div>
        </section>
    )
}

export default EventForm
